import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Tabs, Tab, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

const NavigationBar = ({ mode, toggleTheme }) => {
  const theme = useTheme();

  const location = useLocation();
  const navigate = useNavigate();

  // Determine the selected tab based on the current route.
  let tabValue = 0;
  if (location.pathname === '/') {
    tabValue = 0;
  } else if (location.pathname === '/faith') {
    tabValue = 1;
  } else if (location.pathname === '/fitness') {
    tabValue = 2;
  } else if (location.pathname === '/career') {
    tabValue = 3;
  } else if (location.pathname === '/gallery') {
    tabValue = 4;
  } else if (location.pathname === '/contact') {
    tabValue = 5;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        backgroundColor:
          mode === 'light' ? 'rgba(255,255,255,0.95)' : 'rgba(0,0,0,0.95)',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      <Container>
        <Box
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Tabs
            value={tabValue}
            onChange={(event, newValue) => {
              if (newValue === 0) navigate('/');
              if (newValue === 1) navigate('/faith');
              if (newValue === 2) navigate('/fitness');
              if (newValue === 3) navigate('/career');
              if (newValue === 4) navigate('/gallery');
              if (newValue === 5) navigate('/contact');
            }}
            textColor="inherit"
            indicatorColor="secondary"
            centered
            variant="scrollable" // Enables horizontal scroll on small screens
            sx={{
              flexGrow: 1,
              maxWidth: '100%',
              '& .MuiTab-root': { fontSize: { xs: '0.8rem', sm: '1rem' } },
            }}
          >
            <Tab label="Home" />
            <Tab label="Faith" />
            <Tab label="Fitness" />
            <Tab label="Career" />
            <Tab label="Gallery" />
            <Tab label="Contact" />
          </Tabs>
          <Box sx={{ position: 'absolute', right: 0 }}>
            <IconButton onClick={toggleTheme} sx={{ color: 'inherit' }}>
              {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NavigationBar;
